module.exports = __webpack_public_path__ + "static/media/history.8bb383c2.jpg";